module.exports = __webpack_public_path__ + "static/media/tacofactory.96deb47e.png";